import Radha from "../assets/radha.jpg";
import Radha2 from "../assets/radha2.jpeg";
import Kasol1 from "../assets/Kasol1.jpg";
import Kasol2 from "../assets/kasol2.jpg";
import "./DestinationStyle.css";
import DestinationData from "./DestinationData";
const Destination = () => {
    return (
      <div classname="destination">
        <h1>Popular Destinations</h1>
        <p>Tours gives you oppurtunity to explore</p>
        <DestinationData
        className="first-des"

        heading="Radhangar Beach"
        text="
        Radhanagar Beach in Havelock Island is the most visited beach 
        in the entire Andaman and Nicobar Islands. Radhanagar Beach is considered 
        the most excellent beach in the entire Andaman Islands and not that just we say 
        this, it was ranked the 7th best beach in Asia in 2004 and in 2020.
        Radhanagar beach has been consistently awarded as one of the best beaches in India.
     "
     img1={Radha}
     img2={Radha2}
     
        />
        <DestinationData
        className="first-des-reverse"
        heading="Kasol"
        text="
        Kasol is a quaint little village in Himachal situated along the banks of the river Parvati. Commonly known as the 'Amsterdam of India'.
        Kasol is a hamlet in the Kullu district of the Indian state of Himachal Pradesh.
         It is situated in Parvati Valley, on the banks of the Parvati River, Between Bhuntar and Manikaran,
          it is located 30 km (19 mi) from Bhuntar and 36 km (22 mi) from Kullu town, the district headquarters,
           3.5 km from Manikaran. Kasol is the Himalayan hotspot for backpackers and acts as a base for nearby treks to Malana and Kheerganga.
            It is called Mini Israel of India due to a high percentage of Israeli tourists here."
     img1={Kasol1}
     img2={Kasol2}
     
        />
      </div>
    );
  };
  export default Destination;
  